import { render, staticRenderFns } from "./BudgetAlertsCreateComponent.vue?vue&type=template&id=62493b66"
import script from "./BudgetAlertsCreateComponent.vue?vue&type=script&lang=js"
export * from "./BudgetAlertsCreateComponent.vue?vue&type=script&lang=js"
import style0 from "./BudgetAlertsCreateComponent.vue?vue&type=style&index=0&id=62493b66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports